module.exports = __webpack_public_path__ + "static/img/12.fa8563d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/12.jpg
// module id = 8MA0
// module chunks = 0